import { TwoWaySlabInput } from '@core/const'
import { Dispatch, PropsWithChildren, SetStateAction, createContext, useContext, useMemo, useState } from 'react'
import { UseFormReturn, useForm } from 'react-hook-form'

const defaultFormValues: TwoWaySlabInput = {
  longSideSpan: 0,
  shortSideSpan: 0,
}

interface TwoWaySlabContext {
  form: UseFormReturn<TwoWaySlabInput>
  result: number | null
  setResult: Dispatch<SetStateAction<number | null>>
}

const context = createContext<TwoWaySlabContext | undefined>(undefined)

const useDefaultContextValues = () => {
  const form = useForm<TwoWaySlabInput>({
    defaultValues: defaultFormValues,
  })

  const [result, setResult] = useState<number | null>(null)

  return useMemo(() => ({
    form,
    result,
    setResult,
  }), [form, result])
}

export function TwoWaySlabProvider ({ children }: PropsWithChildren) {
  const { Provider } = context
  const defaultContextValues = useDefaultContextValues()

  return (
    <Provider value={defaultContextValues}>
      {children}
    </Provider>
  )
}

export const useTwoWaySlab = () => {
  const contextValues = useContext(context)
  const defaultContextValues = useDefaultContextValues()

  return contextValues ?? defaultContextValues
}
